import {Storage} from "@/Services/Storage";
import axios from "axios";

export default {
    name: 'user',
    state: {
        allUsers : [],
        kazangUsers : [],
        currentUser : {}
    },
    getters: {
        getAllUsers: (state) => state.allUsers,
        getKazangUsers: (state) => state.kazangUsers,
        getCurrentUser : (state) => state.currentUser,
    },
    mutations: {
        // setAllUsers: async (state, payload) => {
        //     if (payload) await Storage.setAllUsers(payload)
        //     else payload = await Storage.getAllUsers();
        //     state.allUsers = payload?payload : [];
        // },

        setAllUsers: async (state, data) => {
            state.allUsers = data;
        },
        setAllKazangUsers: async (state, data) => {
            state.kazangUsers = data;
        }
    },
    actions: {
        getAllUsers: async (context) => {
            return axios.get(ticketApi + `user/getAll`)
                .then(({data}) => {
                    context.commit('setAllUsers', data)
                });
        },
        getAllKazangUsers: async (context) => {
            return axios.get(overflowSupApi + `users/all`)
            .then(({data}) => {
                context.commit('setAllKazangUsers', data)
            })
        },
        createUser: (context, payload) => {
            return axios.post(overflowSupApi + `users/create`, payload)
                .then(({data}) => {console.log(data)})
        },
        updateUser: (context, payload) => {
            return axios.post(overflowSupApi + `users/update/${payload.id}`, payload)
                .then(({data}) => {console.log(data)})
        },
        deleteUser: (context, payload) => {
            return axios.delete(overflowSupApi + `users/delete/${payload}`)
                .then(({data}) => {console.log(data)})
        },
        triggerResetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${synergy}employee/resetPassword`,
                payload:{
                    email: payload,
                }
            })
        },
        resetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${synergy}employee/processResetPassword`,
                payload,
                method: "post"
            })
        },
    }
}
